import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';
import DataTable from 'react-data-table-component';

import { API_BASE_URL } from '../../config.js';
import {
  statisticsAction,
  statisticsCloseAction
} from '../../actions/settingsAction.js';

const Hrot = ({ fixNavbar }) => {

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    axios.get(API_BASE_URL + '/hr_overtime_list', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
      .then(res => setData(res.data || []))
      .catch(() => toast.error("Failed to load overtime list"));
  }, []);

  /* ================= SEARCH ================= */
  const filteredData = data.filter(item =>
    `${item.employee_id}${item.employee_name}${item.department_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    {
      name: "Action",
      cell: row =>
        row.dpt_status === 2 && row.hr === 1 ? (
          <Link to={`/hrcalcot?id=${row.overtime_id}`} title="View Details">
            <i className="fe fe-maximize" />
          </Link>
        ) : null,
      ignoreRowClick: true,
      width: "80px",
    },
    {
      name: "Employee ID",
      selector: row => row.employee_id,
      sortable: true,
    },
    {
      name: "Employee",
      selector: row => row.employee_name,
      sortable: true,
    },
    {
      name: "Department",
      selector: row => row.department_name,
      sortable: true,
    },
    {
      name: "Overtime Hours",
      selector: row => row.overtime_hour,
      sortable: true,
    },
    {
      name: "Applied On",
      selector: row => row.applied_on,
      sortable: true,
    },
    {
      name: "Reason",
      selector: row => row.reason,
      wrap: true,
    },
    {
      name: "Incharge",
      cell: row => ReactHtmlParser(row.incharge_status),
    },
    {
      name: "HOD",
      cell: row => ReactHtmlParser(row.hod_status),
    },
    {
      name: "HR",
      cell: row => ReactHtmlParser(row.hr_status),
       sortable: true,
    },
    {
  name: "ManualOT",
  cell: row =>
    row.manual_ot === 1 ? (
      <span className="badge badge-danger">Manual OT</span>
    ) : (
      <span className="badge badge-secondary">---</span>
    ),
  sortable: true,
}

    
  ];

  return (
    <>
      <ToastContainer />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">
          <div className="card">

            {/* HEADER */}
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="card-title mb-0" style={{ color: '#e96827' }}>
                Overtime List
              </h3>

              <div style={{ position: "relative", width: "300px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ paddingRight: "30px" }}
                />
                {searchTerm && (
                  <span
                    onClick={() => setSearchTerm("")}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#aaa",
                      fontSize: "18px"
                    }}
                  >
                    ✖
                  </span>
                )}
              </div>
            </div>

            {/* TABLE */}
            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                striped
                responsive
                persistTableHead
                noDataComponent="No overtime records found"
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
  statisticsOpen: state.settings.isStatistics,
  statisticsClose: state.settings.isStatisticsClose,
});

const mapDispatchToProps = (dispatch) => ({
  statisticsAction: (e) => dispatch(statisticsAction(e)),
  statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hrot);
